import React from 'react';
import { Camera, Clock, User, PlayCircle } from 'lucide-react';
import { Link } from 'react-router-dom';

// Datos de ejemplo que simulan una respuesta de Modality Worklist
const mockWorklist = [
    {
        studyUID: '1.2.3.4.5', patientName: 'Pérez, Juan',
        patientId: 'PID-00123',
        studyDescription: 'RX TÓRAX PA Y LATERAL',
        modality: 'CR', // Computed Radiography
        requestingPhysician: 'Dr. Alejandro Magno',
        scheduledTime: '10:30',
        status: 'PENDIENTE'
    },
    {
        studyUID: '6.7.8.9.0', patientName: 'García, María',
        patientId: 'PID-00456',
        studyDescription: 'USG ABDOMINAL',
        modality: 'US', // Ultrasound
        requestingPhysician: 'Dra. Isabela Castillo',
        scheduledTime: '11:00',
        status: 'PENDIENTE'
    },
    {
        studyUID: '1.3.5.7.9', patientName: 'López, Carlos',
        patientId: 'PID-00789',
        studyDescription: 'TC CRÁNEO SIMPLE',
        modality: 'CT', // Computed Tomography
        requestingPhysician: 'Dr. Alejandro Magno',
        scheduledTime: '11:30',
        status: 'PENDIENTE'
    },
];

const ImagingWorklistPage = () => {
    return (
        <div className="p-8 font-sans">
            <div className="flex justify-between items-center mb-8">
                <h1 className="text-3xl font-bold text-gray-800 flex items-center">
                    <Camera className="mr-3 text-blue-600" />
                    Worklist de Imagenología
                </h1>
                <div className="text-right">
                    <p className="text-gray-600">Usuario: <strong>Técnico Radiólogo</strong></p>
                    <p className="text-gray-500 text-sm">Clínica Central</p>
                </div>
            </div>

            <div className="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="w-full text-left">
                        <thead className="bg-gray-50 text-gray-600 text-sm uppercase">
                            <tr>
                                <th className="px-6 py-4 font-semibold">Paciente</th>
                                <th className="px-6 py-4 font-semibold">ID Paciente</th>
                                <th className="px-6 py-4 font-semibold">Estudio Solicitado</th>
                                <th className="px-6 py-4 font-semibold">Modalidad</th>
                                <th className="px-6 py-4 font-semibold">Médico Solicitante</th>
                                <th className="px-6 py-4 font-semibold">Hora</th>
                                <th className="px-6 py-4 font-semibold text-center">Acción</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200">
                            {mockWorklist.map((study, index) => (
                                <tr key={index} className="hover:bg-gray-50 transition-colors">
                                    <td className="px-6 py-4 font-medium text-gray-900">{study.patientName}</td>
                                    <td className="px-6 py-4 text-gray-700">{study.patientId}</td>
                                    <td className="px-6 py-4 text-gray-700">{study.studyDescription}</td>
                                    <td className="px-6 py-4"><span className="bg-gray-200 text-gray-800 text-xs font-bold px-2 py-1 rounded-full">{study.modality}</span></td>
                                    <td className="px-6 py-4 text-gray-700">{study.requestingPhysician}</td>
                                    <td className="px-6 py-4 text-gray-700 flex items-center"><Clock size={16} className="mr-2 text-gray-400" />{study.scheduledTime}</td>
                                    <td className="px-6 py-4 text-center">
                                        <Link to={`/reportar/${study.studyUID}`} className="bg-blue-500 text-white px-4 py-2 rounded-lg font-semibold hover:bg-blue-600 transition-colors flex items-center justify-center mx-auto">
                                            <PlayCircle size={18} className="mr-2" /> Iniciar Estudio
                                        </Link>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default ImagingWorklistPage;